import ko from 'knockout';

//hooked plain foreach
ko.bindingHandlers.foreach2 = {
	init: ko.bindingHandlers.foreach.init,
	update: (element, valueAccessor, ...args) => {
		const options = ko.unwrap(valueAccessor());
		const data = ko.unwrap(options.data);

		if (options.beforeRenderAll) {
			options.beforeRenderAll(data);
		}

		ko.bindingHandlers.foreach.update(element, valueAccessor, ...args);

		if (options.afterRenderAll) {
			options.afterRenderAll(data);
		}
	},
};
